export const UPLOAD = 'upload';
export const STOCK = 'stock';
export const GIF = 'gif';

export default [UPLOAD, STOCK, GIF];
